import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { MixpanelEvent } from 'src/app/shared/model/mix-panel-event.enum';
import { MixpanelService } from 'src/app/shared/service/mix-panel.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  copyright:any
  footerList:any;
  header:any;
  constructor(private service:AdminService,
    private mixpanelService:MixpanelService) { }

  ngOnInit(): void {
    this.service.getCopyright().subscribe(data=>{
      this.copyright = data.copyRightText
    })

    this.service.getAllFooterSections().subscribe((res:any)=>{
      this.footerList = res.filter((v:any)=> v.section !== 'Header');
      this.header = res.find((v:any)=> v.section == 'Header')
    }, err=>{
      console.log(err)
    })
  }
  trackEvent(title:string){
    this.mixpanelService.trackEvent({
      event:MixpanelEvent.BUTTON_CLICKED,
      properties:{
        title:title,
        feature_context:"FOOTER"
      }
    })
  }

  onGooglePlayButton(){
    this.trackEvent('google_play_store_button');
    window.open('https://play.google.com/store/apps/details?id=com.creatics.mobile.live', '_blank');
  }
    onAppleStoreButton(){
    this.trackEvent('apple_store_button');
    window.open('https://apps.apple.com/app/id1613121215', '_blank');
  }

}
